import { OIDCService } from '../constants/UserManager';
import { HubConnectionBuilder } from '@microsoft/signalr';
import { SessionStorageService } from './SessionStorageService';

export const SignalrProvider = {
    initializeConnection: () => {
        const signalRUrl = `${window.$config.signalRHub}/signalR`;
        const newConnection = new HubConnectionBuilder()
            .withUrl(signalRUrl)
            .withAutomaticReconnect().build();

        newConnection.start()
            .then(result => {
                newConnection.on('SendMessage', processSignalRMessage);
            }).catch();
    }
}


const processSignalRMessage = (msg) => {
    msg = JSON.parse(msg);
    if (msg.hub == "userEmailConfirmed" && msg.userId) {
        let user = OIDCService.getUser();
        if (user != undefined && user.profile.sub == msg.userId && window.location.pathname.includes('emailActivationPending')) {
            user.profile.EmailConfirmed = 'True';
            OIDCService.setUser(user);
            let postLoginRoute = SessionStorageService.getPostLoginUrl();
            SessionStorageService.removePostLoginUrl();
            postLoginRoute = postLoginRoute ? postLoginRoute : "/";
            window.location.href = window.location.origin + '' + postLoginRoute;
        }
    } else if (msg.hub == "notifyUserDetailChanged" && msg.userId) {
        let user = OIDCService.getUser();
        if (user != undefined && user.profile.sub == msg.userId && msg.isForceLogout == true) {
            OIDCService.logout();
        }
    }
}